<template>
  <div>
    <svg-component />
    <router-view />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { storeToRefs } from "pinia";
import { useQuasar } from "quasar";
import { useSettingsStore } from "./stores/settings";
import SvgComponent from "src/components/svg/SvgComponent.vue";

defineOptions({ name: "App" });

const $q = useQuasar();
const settingsStore = useSettingsStore();
const { dark } = storeToRefs(settingsStore);

watch(dark, (isDark) => {
  $q.dark.set(isDark);
});
</script>
